import React, { FC, StrictMode } from 'react';
import { App } from './routes/App';
import { CloverPaymentIframeProvider } from 'hooks/context/cloverPaymentIframe';

import 'clover-css/main.scss';
import 'styles/global.scss';

export const Root: FC = () => (
  <StrictMode>
    <CloverPaymentIframeProvider>
      <App />
    </CloverPaymentIframeProvider>
  </StrictMode>
);
